<template>
    <el-dialog class="el-dialogs" :title="title" width="500px" :close-on-click-modal="false"
               :visible.sync="visible">
        <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
                 label-width="100px">
            <el-form-item label="流程名称：" prop="flowName">
                <el-input v-model.trim="searchForm.flowName" maxlength="20"
                          placeholder="请输入流程名称(限20字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item label="流程说明：" prop="flowExplain">
                <el-input v-model.trim="searchForm.flowExplain" maxlength="500"
                          type="textarea" :rows="5" resize="none"
                          placeholder="请输入流程说明(限500字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item label="状态：" prop="status">
                <el-switch
                        v-model="searchForm.status"
                        active-value="0"
                        inactive-value="1">
                </el-switch>
            </el-form-item>
            <el-form-item label="流程设置：" prop="process">
                <div class="processHeight">
                    <el-steps direction="vertical">
                        <el-step v-for="(item,index) in searchForm.process" :key="index" status="finish">
                            <template slot="description">
                                <div :class="[index != 0 ? 'magToph' : '']">
                                    <div v-show="!item.edit" class="flex_l_c">
                                        <div class="contentName omit">{{ item.name }}</div>
                                        <div v-show="!stepEdit" class="contentSet">
                                            <i @click="addProcedure(index)" class="el-icon-circle-plus-outline" v-show="(index + 1) != searchForm.process.length"></i>
                                            <i @click="deleteProcedure(index)" v-show="index != 0 && (index + 1) != searchForm.process.length"
                                               class="el-icon-remove-outline"></i>
                                        </div>
                                    </div>
                                    <div v-show="item.edit" class="flex_l_c">
                                        <treeSelect ref="menuParentTree"
                                                    class="contentName"
                                                    :props="{
                                           children: 'children',
                                           label: 'name',
                                           value:'id'
                                          }"
                                                    :data="parentIdList"
                                                    :value="item.id"
                                                    :clearable="true"
                                                    :accordion="true"
                                                    @getValue="(val, label, node)=>selectCascader(val, label, node,item,index)"
                                        ></treeSelect>
                                        <div class="contentSet">
                                            <i @click="saveProcedure(item)" class="el-icon-circle-check"></i>
                                            <i @click="deleteProcedure(index)" class="el-icon-circle-close"></i>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </el-step>
<!--                        <el-step status="finish">-->
<!--                            <template slot="description">-->
<!--                                <div class="contentName omit">结束</div>-->
<!--                            </template>-->
<!--                        </el-step>-->
                    </el-steps>
                </div>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>提交</el-button>
            <el-button size="small" @click="visible = false">取消</el-button>
        </div>
    </el-dialog>
</template>

<script>
import treeSelect from "@/components/treeSelect/treeSelect.vue";

export default {
    name: "addProcess",
    components: {treeSelect},
    data() {
        return {
            title: '新增流程',
            visible: false,
            searchForm: {
                id: '',
                flowName: '',
                flowExplain: '',
                status: '1',
                flowMenu: '',
                process: [
                    {
                        name: '开始',
                    },
                ],
            },
            rules: {
                flowName: [
                    {required: true, message: '请输入流程名称', trigger: 'blur'}
                ],
            },
            stepEdit: false,
            parentIdList: [],
            disableRouting: ['菜单管理', '用户管理', '个人中心', '消息中心', '系统设置', '工作台','功能模板管理','业务功能配置','黑名单','元数据管理','组织机构','系统管理'],
        }
    },

    computed: {
        parentIdListAll() {
            return this.$store.state.common.leftMenuList
        }
    },

    methods: {
        //typeName edit编辑 add新增
        init(typeName, row) {
            this.searchForm.id = ''
            this.searchForm.process = [
                {
                    name: '开始',
                },
                {
                    name: '结束',
                },
            ]
            if (typeName == 'add') {
                this.title = '新增流程'
            }
            if (typeName == 'edit') {
                this.title = '编辑流程'
                this.getDetail(row.id)
            }
            this.visible = true
            this.$nextTick(() => {
                this.$refs.searchForm.resetFields()
            })
            this.getparentList()
        },

        getDetail(id) {
            this.$axios(this.api.dyygRelease.releasesFlowGetById + id).then(data => {
                if (data && data.status) {
                    Object.keys(this.searchForm).forEach(key => {
                        if (data.data[key]) {
                            this.searchForm[key] = data.data[key]
                        }
                    })
                    this.searchForm.process.splice(1, 0,...data.data.flowList)
                    // this.searchForm.process.push(...data.data.flowList)
                }
            })
        },

        getparentList() {
            this.parentIdList = JSON.parse(JSON.stringify(this.parentIdListAll))
            this.parentIdList = this.setParentList(this.parentIdList)
        },

        setParentList(list) {
            if (!list || list.length == 0) {
                return
            }
            let dataList = list.filter(item => {
                let screen = this.disableRouting.filter(item2 => {
                    return item.name == item2
                })
                if (item.children && item.children.length > 0) {
                    item.children = this.setParentList(item.children)
                }
                return screen.length == 0
            })
            return dataList
        },

        //添加流程节点
        addProcedure(index) {
            this.stepEdit = true
            this.searchForm.process.splice(index + 1, 0, {
                id: '',
                name: '',
                edit: true,
            })
        },

        //选择菜单
        selectCascader(val, name, node, row, index) {
            let reapet = this.searchForm.process.filter(item => {
                return item.id == val
            })
            if (!node.href) {
                this.$refs.menuParentTree[index].valueTitle = ''
                this.$refs.menuParentTree[index].valueId = ''
                row.id = ''
                row.name = ''
                this.$message('不支持选择目录，请选择菜单')
                return;
            }
            if (reapet && reapet.length) {
                this.$message('不支持选择重复菜单')
                this.$refs.menuParentTree[index].valueTitle = ''
                this.$refs.menuParentTree[index].valueId = ''
                row.id = ''
                row.name = ''
                return
            }
            row.id = val
            row.name = name
        },

        //保存单个节点
        saveProcedure(row) {
            if (row.id == '') {
                this.$message.warning('请选择菜单')
                return
            }
            row.edit = false
            this.stepEdit = false
        },

        //删除单个节点
        deleteProcedure(index) {
            this.searchForm.process.splice(index, 1)
            this.stepEdit = false
        },

        doSubmit() {
            let editList = this.searchForm.process.filter(item => {
                return item.edit == true
            })
            if (editList.length) {
                this.$message.warning('请先保存流程设置')
                return
            }
            this.searchForm.flowMenu = ''
            this.searchForm.process.forEach(item => {
                if (item.id && item.id != '') {
                    this.searchForm.flowMenu = this.searchForm.flowMenu ? (this.searchForm.flowMenu + ',' + item.id) : item.id
                }
            })
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    if (this.searchForm.id) {
                        this.$axios(this.api.dyygRelease.releasesFlowUpdateById, this.searchForm, 'put').then(data => {
                            if (data && data.status) {
                                this.$message.success('编辑成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        this.$axios(this.api.dyygRelease.releasesFlowSave, this.searchForm, 'post').then(data => {
                            if (data && data.status) {
                                this.$message.success('保存成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            })
        },
    },
}
</script>

<style scoped>
.el-dialogs >>> .el-dialog__body {
    height: auto !important;
}

.processHeight {
    max-height: 200px;
    overflow-y: auto;

    .contentName {
        font-size: 16px;
        height: 32px;
        line-height: 25px;
        width: 200px;
    }

    .contentSet {
        font-size: 18px;
        height: 32px;
        line-height: 25px;
        margin-left: 40px;

        i {
            margin-right: 10px;
            cursor: pointer;
        }
    }
}
</style>